"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var services_1 = require("../../services");
function getFiltersFromLocation() {
    return services_1.parse(services_1.getHistory().location.search);
}
exports.default = getFiltersFromLocation;
//# sourceMappingURL=getFiltersFromLocation.js.map